module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAiCAMAAADmrkDzAAAAS1BMVEUAAACoawGoawGoawGoawGoawGoawGoawGoawGoawGoawGoawGoawGoawGoawGoawGoawGoawGoawGoawGoawGoawGoawGoawGoawHLmvFVAAAAGHRSTlMABtMOChvby8XAFbawqqOdlo+7iIEfEt0cvZZHAAAArUlEQVQ4y4XTVxKDMAxFUZlqeidv/ytNGIYALnr3+wyDbUmcNruJWv5BkaugAFRSJzhK6hjYf+AkexikJa7KNAgs7myAZBWeVZkHZrybHWIauDXmBVr4teYBOoTqzB/0CNdfZECs4QQj4o0HmKA1iSzQW2Vlgn1kYT8yscOMQi5kEHKpPXuYjj1ua8iANIZM4TFiHrHamN7bcI+6SsqUbeVOFjepyfIXuahtlQu+6W40D47Y2FYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/media.png
// module id = hLVp
// module chunks = 0